// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.lee-menu-tree[data-v-d8d2c4b8]{background: #fff}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
